export default __webpack_public_path__ + "static/char-s-59-en-50b762e1bfb15a0318f8ffb0beef634c.png";